// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Reports = [
  {
    title: 'Factory Order Sheet',
    path: '/dashboard/Reports/FactoryOrderSheet',
    icon: icon('track'),
    ShortName: 'FactoryOrderSheet_Report',
  },
  {
    title: 'Inspection Report',
    path: '/dashboard/Reports/InspectionReport',
    icon: icon('track'),
    ShortName: 'InspectionReport_Report',
  },{
    title: 'Defect Summary',
    path: '/dashboard/Reports/DefectSummary',
    icon: icon('track'),
    ShortName: 'DefectSummary_Report',
  },
];

export default Reports;
